/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export const endVisitOptions = {
	method: 'POST',
	url: '/_api/v1/homehealth/visits/commands/endvisit'
};
